import { render, staticRenderFns } from "./ServicesChart.vue?vue&type=template&id=0a49bfa4&scoped=true"
import script from "./ServicesChart.vue?vue&type=script&lang=js"
export * from "./ServicesChart.vue?vue&type=script&lang=js"
import style0 from "./ServicesChart.vue?vue&type=style&index=0&id=0a49bfa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a49bfa4",
  null
  
)

export default component.exports